// extracted by mini-css-extract-plugin
export default {"InfoAdpx":"InfoAdpx_InfoAdpx__9oes5","Popover":"InfoAdpx_Popover__xDcif","BoutonClose":"InfoAdpx_BoutonClose__Kerxg","Detail":"InfoAdpx_Detail__Jqw-r"};